import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-training-timeline',
  templateUrl: './training-timeline.component.html',
  styleUrl: './training-timeline.component.scss'
})
export class TrainingTimelineComponent implements OnChanges {
@Input() isToolTip : boolean = false
@Input() sessions : any = [];

ngOnChanges(changes: SimpleChanges) {
  this.sessions = this.sessions
}


}
